import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography } from '@material-ui/core';
import OEMPartList from './OEMPartList';
import { hasPermission } from '../sc-utilities';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    yes: {
        color: theme.palette.success.main
    },
    no: {
        color: theme.palette.error.main
    }
});

const OEMPart = props => {
    const tableRef = useRef();
    const { columns, classes, translations, permissions } = props;

    let visible = columns && columns['OEMPart'];

    const tableColumns = [
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["factory_value"] || 'Factory Value', field: 'Factory Value',
            hidden: visible ? visible['FactoryValue'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FactoryValue ? rowData.FactoryValue : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["current_value"] || 'CurrentValue', field: 'Current Value',
            hidden: visible ? visible['CurrentValue'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CurrentValue ? rowData.CurrentValue : translations['short_not_assigned'] || 'n/a'}</Typography>;

            }
        },
        {
            title: translations["same_as_original"] || 'Same as original', field: 'SameAsOriginal',
            hidden: visible ? visible['CurrentValue'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'} className={classes[`${rowData.CurrentValue === rowData.FactoryValue ? 'yes' : 'no'}`]}>{rowData.CurrentValue === rowData.FactoryValue ? 'Yes' : 'No'}</Typography>;
            }
        }
    ];

    return (
        <div className={classes.root}>
            {
                hasPermission(permissions, 'oem_part_list') ?
                    <OEMPartList
                        tableColumns={tableColumns}
                        tableRef={tableRef}
                    /> : null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
}

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(OEMPart));
